exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#mw .mw-mini-modal--auto-height,#mw .mw-mini-modal--auto-height .mw-dialog__content,#mw .mw-mini-modal--auto-height .mw-mini-modal-dialog,#mw .mw-mini-modal--auto-height .mw-mini-modal-wrapper{height:auto;min-height:0;-ms-flex:0 1 auto;flex:0 1 auto}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./apps-ts/outputs/src/app/newsfeeds/newsfeed-data-table/newsfeed-data-table.component.css
 ** module id = 60
 ** module chunks = 0 1
 **/